import CustomTextarea from 'Common/CustomTextArea';
import React, { useState } from 'react'
import { LuChevronDown } from "react-icons/lu";
const PaymentNote = ({ note, handlePaymentNote }) => {
    const [showNote, setShowNote] = useState(false);
    return (
        <>
            <button onClick={() => setShowNote(!showNote)} className="flex items-center gap-2 text-sm text-slate-600 hover:text-slate-800"  >
                <LuChevronDown className={`w-4 h-4 transition-transform ${showNote ? 'rotate-180' : ''}`} />
                Note
            </button>
            {showNote && (
                <>
                    <CustomTextarea
                        label="Note"
                        value={note}
                        name="notes"
                        onChange={handlePaymentNote}
                        placeholder="Add a note about this payment..." />
                    <div className='text-right'>
                        <span> {note?.length} </span>
                        <span>/ 500</span>
                    </div>
                </>

            )}
        </>
    )
}

export default PaymentNote